import { SVGProps } from "react";

export default function BalanceIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24, fill = "#292D32", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M13.6035 13.8906V13.8916C13.8623 13.9829 13.9402 14.0338 13.9834 14.0869C14.019 14.1307 14.0898 14.2537 14.0898 14.6406C14.0897 15.0989 13.7405 15.4197 13.4004 15.4199H13.2598V13.7725L13.6035 13.8906Z"
        fill={fill}
        stroke={fill}
      />
      <path
        d="M11.9701 1.90041C6.45007 1.92041 1.98007 6.41041 2.00007 11.9304C2.02007 17.4504 6.51007 21.9204 12.0301 21.9004C17.5501 21.8804 22.0201 17.3904 22.0001 11.8704C21.9801 6.35041 17.4901 1.89041 11.9701 1.90041ZM14.2601 12.0004C15.0401 12.2704 16.0901 12.8504 16.0901 14.6404C16.0901 16.1804 14.8801 17.4204 13.4001 17.4204H12.7501V18.0004C12.7501 18.4104 12.4101 18.7504 12.0001 18.7504C11.5901 18.7504 11.2501 18.4104 11.2501 18.0004V17.4204H10.8901C9.25007 17.4204 7.92007 16.0404 7.92007 14.3404C7.92007 13.9304 8.26007 13.5904 8.67007 13.5904C9.08007 13.5904 9.42007 13.9304 9.42007 14.3404C9.42007 15.2104 10.0801 15.9204 10.8901 15.9204H11.2501V12.5404L9.74007 12.0004C8.96007 11.7304 7.91007 11.1504 7.91007 9.36041C7.91007 7.82041 9.12007 6.58041 10.6001 6.58041H11.2501V6.00041C11.2501 5.59041 11.5901 5.25041 12.0001 5.25041C12.4101 5.25041 12.7501 5.59041 12.7501 6.00041V6.58041H13.1101C14.7501 6.58041 16.0801 7.96041 16.0801 9.66041C16.0801 10.0704 15.7401 10.4104 15.3301 10.4104C14.9201 10.4104 14.5801 10.0704 14.5801 9.66041C14.5801 8.79041 13.9201 8.08041 13.1101 8.08041H12.7501V11.4604L14.2601 12.0004Z"
        fill={fill}
      />
      <path
        d="M9.42188 9.37008C9.42188 10.2401 9.73187 10.4101 10.2419 10.5901L11.2519 10.9401V8.08008H10.6019C9.95188 8.08008 9.42188 8.66008 9.42188 9.37008Z"
        fill={fill}
      />
    </svg>
  );
}
